import React, { ComponentProps, ReactNode, useContext, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import classNames from 'clsx';

import breakpoints from '@/mui/constants/breakpoints';

import { RootContainers } from '../../helpers';
import * as commonSelectors from '../../redux/selectors/common';
import { BreakpointsContext } from './helpers';

import { IsInPopupContext } from '../../components/PagePopup/PagePopup';
import { Box } from '@/mui/components';

import styles from './BreakpointsProvider.module.scss';

const entriesBreakpoints = [...Object.entries(breakpoints.values), ['infinity', Infinity]] as [string, number][];

const getCssBreakpoints = (width: number): string => {
  const classes: string[] = [];
  for (let i = 0; i < entriesBreakpoints.length; i += 1) {
    const [startKey, startValue] = entriesBreakpoints[i];

    for (let k = i + 1; k < entriesBreakpoints.length; k += 1) {
      const [endKey, endValue] = entriesBreakpoints[k];

      if (width >= startValue && width <= endValue - 1) {
        classes.push(`${startKey}-${endKey}`);
      }
    }
  }

  return classes.join(' ');
};

type BreakpointsWrapperProps = {
  children?: ReactNode;
  className?: string;
} & ComponentProps<typeof Box>;

function BreakpointsWrapper({ children, className = '', ...props }: BreakpointsWrapperProps) {
  const isInPopup = useContext(IsInPopupContext);
  const popupSize = useSelector(commonSelectors.popupSizeSelector);

  const [breakpoint, setBreakpoint] = useState(() =>
    getCssBreakpoints(RootContainers.getMainWidth(isInPopup, popupSize)),
  );

  useEffect(() => {
    const fnResize = () => setBreakpoint(getCssBreakpoints(RootContainers.getMainWidth(isInPopup, popupSize)));

    fnResize();

    window.addEventListener('resize', fnResize);

    return () => {
      window.removeEventListener('resize', fnResize);
    };
  }, [isInPopup, popupSize]);

  return (
    children && (
      <BreakpointsContext.Provider value={breakpoint}>
        <Box {...props} className={classNames(styles.Wrapper, breakpoint, className)}>
          {children}
        </Box>
      </BreakpointsContext.Provider>
    )
  );
}

export default BreakpointsWrapper;
